import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Globe } from 'lucide-react';
import { LogoIcon } from '../components/Logo';
import { BrazilFlag, USAFlag, EUFlag, UKFlag } from '../components/FlagIcons';

const LandingPage = () => {
  const navigate = useNavigate();

  const countries = [
    {
      code: 'br',
      name: 'Brasil',
      FlagComponent: BrazilFlag,
      description: 'Soluções adaptadas para o mercado brasileiro'
    },
    {
      code: 'us',
      name: 'United States',
      FlagComponent: USAFlag,
      description: 'Solutions for the North American market'
    },
    {
      code: 'eu',
      name: 'European Union',
      FlagComponent: EUFlag,
      description: 'Solutions compliant with European regulations'
    },
    {
      code: 'uk',
      name: 'United Kingdom (UK)',
      FlagComponent: UKFlag,
      description: 'Solutions for the UK market'
    }
  ];

  const handleCountrySelect = (code) => {
    navigate(`/${code}`);
  };

  return (
    <div className="min-h-screen relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #F5F1E8 0%, #E8DCC8 50%, #F5F1E8 100%)' }}>
      {/* Logo de fundo mais evidente */}
      <div className="absolute inset-0 flex items-center justify-center opacity-15 pointer-events-none">
        <LogoIcon size={900} />
      </div>

      {/* Background pattern sutil */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, rgba(27, 94, 32, 0.2) 1px, transparent 1px)',
          backgroundSize: '40px 40px'
        }} />
      </div>

      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-4 py-12">
        {/* Logo Principal */}
        <div className="mb-8 text-center">
          <div className="mx-auto mb-6 flex items-center justify-center drop-shadow-lg">
            <LogoIcon size={180} />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-2 drop-shadow-sm">
            <span style={{ color: '#1B5E20' }}>AGRO URBAN </span>
            <span style={{ color: '#F9A825' }}>GLOBAL</span>
          </h1>
        </div>

        {/* Welcome Text */}
        <div className="text-center mb-12 max-w-3xl bg-white/40 backdrop-blur-sm rounded-2xl p-8 shadow-lg">
          <h2 className="text-4xl md:text-6xl font-bold mb-6 leading-tight" style={{ color: '#1B5E20' }}>
            Connecting Markets Worldwide
          </h2>
          <p className="text-2xl md:text-3xl font-semibold" style={{ color: '#2E7D32' }}>
            Select your country to begin.
          </p>
        </div>

        {/* Country Selection - Opção B (Bandeira Circular Grande) */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl w-full">
          {countries.map((country) => {
            const FlagComponent = country.FlagComponent;
            return (
              <button
                key={country.code}
                onClick={() => handleCountrySelect(country.code)}
                className="bg-white rounded-xl p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group flex flex-col items-center"
                data-testid={`country-${country.code}`}
              >
                {/* Bandeira Circular Grande com SVG */}
                <div className="w-24 h-24 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg" style={{ backgroundColor: '#F5F1E8' }}>
                  <FlagComponent size={72} />
                </div>
                <h3 className="text-xl font-bold mb-2 text-center" style={{ color: '#1B5E20' }}>
                  {country.name}
                </h3>
                <p className="text-aug-gray-medium text-sm text-center mb-3">
                  {country.description}
                </p>
                <div className="mt-2 flex items-center justify-center transition-colors duration-300" style={{ color: '#2E7D32' }}>
                  <Globe className="w-5 h-5 mr-2" />
                  <span className="font-medium">Acessar</span>
                </div>
              </button>
            );
          })}
        </div>

        {/* Footer Links */}
        <div className="mt-16 flex space-x-6 text-sm" style={{ color: '#8D6E63' }}>
          <a href="#" className="hover:opacity-70 transition-opacity duration-300">
            Política de Privacidade
          </a>
          <span>|</span>
          <a href="#" className="hover:opacity-70 transition-opacity duration-300">
            Termos de Uso
          </a>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
